import styled from 'styled-components';

export const NftPriceSummaryTable = styled.div<{ $isLarge?: boolean }>`
  text-align: left;
  width: 100%;
  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    &:not(:last-child) {
      border-bottom: 1px solid var(--v3-black-2);
      padding-bottom: 12px;
    }
    :last-child {
      > div:last-child {
        font-weight: 500;
        font-size: ${props => (props.$isLarge ? 24 : 16)}px;
        line-height: ${props => (props.$isLarge ? 32 : 16)}px;
        color: var(--v3-primary-color);
      }
      > div:first-child {
        color: var(--v3-text-color);
      }
    }
    :not(:first-child) {
      padding-top: 12px;
    }
    > div {
      margin: 0;
      font-weight: 450;
      font-size: ${props => (props.$isLarge ? 20 : 16)}px;
      line-height: ${props => (props.$isLarge ? 32 : 20)}px;
      :first-child {
        color: var(--v3-text-color-secondary);
      }
      :last-child {
        color: var(--v3-text-color);
      }
    }
  }
`;
